export default "ECS solaire collective BAT-TH-152 — Eau chaude solaire tertiaire | Solution Éco France";
